import request from '../../utils/request'

const preFix = '/customizeGoods';

export const reqListCustomizeGoods = (data) => {
    return request({
        url: preFix + '/page',
        method: 'POST',
        data: data
    })
}
export const reqInsertCustomizeGoods = (data) => {
    return request({
        url: preFix + '/insert',
        method: 'POST',
        data: data
    })
}
export const reqUpdateCustomizeGoods = (data) => {
    return request({
        url: preFix + '/update',
        method: 'POST',
        data: data
    })
}
export const reqDeleteCustomizeGoodsById = (data) => {
    return request({
        url: preFix + '/delete',
        method: 'get',
        params: data
    })
}
export const reqGetCustomizeGoodsById = (data) => {
    return request({
        url: preFix + '/detail',
        method: 'get',
        params: data
    })
}
